module.exports = __webpack_public_path__ + "static/media/notification-icon.9a2d6f24.svg";